import PropTypes from 'prop-types';
import SpinnerButton from '../shared/SpinnerButton';
import useEntriDomainPurchase from '../../hooks/useEntriDomainPurchase';

/**
 * Button component that triggers the Entri domain purchase flow
 * Opens the Entri modal for domain purchasing when clicked
 *
 * @param {object} props - Component props
 * @param {string} props.subdomain - Ghost subdomain for DNS configuration (e.g., 'my-site')
 * @param {string} props.siteId - Ghost Pro site id
 * @param {Function} [props.onError] - Optional callback when error occurs
 * @param {Function} [props.onDomainPurchased] - Optional callback when domain is successfully purchased
 * @param {string} [props.id] - Optional ID for the button element
 * @param {string} [props.className='gh-btn gh-btn-green'] - CSS classes for button styling
 * @returns {JSX.Element} The purchase button
 */
export default function EntriPurchaseButton({
    subdomain,
    siteId,
    onError,
    onDomainPurchased,
    id,
    className = 'gh-btn gh-btn-green',
}) {
    const { isLoading, initiatePurchase } = useEntriDomainPurchase({
        subdomain,
        onError,
        onDomainPurchased,
        siteId,
    });

    let buttonHtml = `<span class="gh-btn-text" style="opacity: ${isLoading ? '0' : '1'};">Purchase domain</span>`;
    if (isLoading) {
        // Overlay spinner centered over the transparent text (avoids changing button size)
        buttonHtml +=
            '<span class="gh-spinner" style="left: calc(50% - 9px); top: calc(50% - 9px); position: absolute;"></span>';
    }

    return (
        <>
            <SpinnerButton
                className={`${className} ${isLoading ? 'spinner' : ''}`}
                type="button"
                onClick={initiatePurchase}
                html={buttonHtml}
                disabled={isLoading}
                id={id}
                style={{
                    position: 'relative',
                }}
            />
        </>
    );
}

EntriPurchaseButton.propTypes = {
    subdomain: PropTypes.string.isRequired,
    onError: PropTypes.func,
    onDomainPurchased: PropTypes.func,
    className: PropTypes.string,
};
